import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import DashboardIcon from 'app/ui/icons/DashboardIcon';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import MessagingIcon from 'app/ui/icons/MessagingIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';

export const getInspectorNavigation = (): AppNS.NavigationElement[] => [
  {
    id: 'dashboard',
    name: 'Dashboard',
    url: '/inspector/scheduled-inspections',
    path: '/inspector/scheduled-inspections',
    icon: <DashboardIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'inspections',
    name: 'Inspections',
    url: '/dcra-inspections/inspections',
    path: '/dcra-inspections/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/inspector/messaging/inbox',
    path: '/inspector/messaging',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'profile',
    name: 'Profile',
    url: '/inspector/profile',
    path: '/inspector/profile',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: assetUrl(
      '../../../DOB_Construction_Inspections_User_Guide_for_Admins_and_Inspectors.pdf'
    ),
    path: '/guide',
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
];
